import React, { useRef, useState } from 'react'
import "react-quill/dist/quill.snow.css";
import ReactQuill, { Quill } from 'react-quill'


const Editor = ({note, setNote}) => {

  const SizeStyle = Quill.import('attributors/style/size');
  SizeStyle.whitelist = ["0.75em", "1em", "1.5em", "2.5em", "3.5em", "4.5em"];
  Quill.register(SizeStyle, true);
  const AlignStyle = Quill.import('attributors/style/align');
  AlignStyle.whitelist = ["right", "center", "justify"]
  Quill.register(AlignStyle, true);
  // Quill.register(IndentStyle, true)

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ size: ["0.75em", "1em", "1.5em", "2.5em", "3.5em", "4.5em"] }],
      [{ font: [] }],
      [{ align: ["right", "center", "justify"] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["link", "video"],
      [{ color: [] }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
      [{ background: [] }]
    ]
  };
  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "color",
    "image",
    "background",
    "align",
    "size",
    "font"
  ];
  const quill = useRef();
  const handleChange =(html)=>{
    setNote(html)
  }
  return (
    <div>
      <ReactQuill 
        modules={modules}
        ref={(el) => (quill.current = el)}
        value={note}
        style={{border:"2px solid green"}}
        bounds={`[data-text-editor="form-editor"]`} 
        formats={formats}
        onChange={(val)=>handleChange(val)}
        placeholder="Enter Your Note Here..."
        required
      />
      <hr></hr>
      {/* <h6>Output is </h6>
      <div dangerouslySetInnerHTML={{ __html: note }} /> */}
    </div>
  )
}

export default Editor
